import * as classes from '@common/components/dialog/dialog.scss';

import * as React from 'react';

export interface DialogProperties {
  readonly text: string;
  readonly textYes: string;
  readonly textNo?: string;
  readonly onYesClick?: () => void;
  readonly onNoClick?: () => void;
  readonly closeDialog?: () => void;
}

export class DialogComponent extends React.Component<DialogProperties> {
  constructor(props: DialogProperties) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className={classes.dialog}>
          <div className={classes.inner}>
            <div className="row center-xs">
              <h2 className={classes.text}>{this.props.text}</h2>
            </div>
            <div className="row bottom-xs">
              <div className="col-md-12 text-center">
                <button className="btn btn-primary" onClick={this.props.onYesClick}>
                  {this.props.textYes}
                </button>
                {this.props.textNo &&
                  this.props.onNoClick && (
                    <button className="btn btn-primary" onClick={this.props.onNoClick}>
                      {this.props.textNo}
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.overlay} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialog/dialog.component.tsx